/**
 * Store global pour ouvrir un TaskEditModal depuis n'importe où dans l'app
 * (notifications, futur GlobalSearch, deep-links, Realtime, etc.).
 * Cf. Nova-V3 taskModalStore.
 */
import { create } from 'zustand';

interface TaskModalState {
  taskId: string | null;
  openTask: (taskId: string) => void;
  closeTask: () => void;
}

export const useTaskModalStore = create<TaskModalState>((set) => ({
  taskId: null,
  openTask: (taskId) => set({ taskId }),
  closeTask: () => set({ taskId: null }),
}));
